import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import MainList from './main_list.vue';
import SubList from './sub_list.vue';

formCreate.component('MainList', MainList);
formCreate.component('SubList', SubList);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      rule: [],
      formFunctionCode: 'merge_process_form',
      formParentCode: 'CRM20201127000000116',
    };
  },
  methods: {
    // 完成渲染
    formComplete() {
      if (this.formConfig.code === 'view') {
        request.post('/mdm/mdmcustmainsubrelation/query', {
          approveId: this.formConfig.row.id,
        }).then((res) => {
          if (res.success) {
            this.getRule('mainList').props.mainList = res.result.mainCustomerMsgs ? res.result.mainCustomerMsgs : [];
            this.getRule('subList').props.subList = res.result.subCustomerMsgs ? res.result.subCustomerMsgs : [];
            this.setValue({
              ...res.result,
            });
          }
        });
      }
    },
    // 提交
    submit() {
      this.$emit('onClose');
    },
  },
};
